import { Box, HStack } from '@chakra-ui/react';

import { getFeesForType } from 'common/fees';
import { formatAmount } from 'common/formatAmount';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import Tooltip from 'components/_core/Tooltip';
import { VAT_RATE } from 'helpers/amount';

import { DetailedTransactionFragment } from '../graphql/fragment/detailedTransaction.gql';
import locales from './locales';

const ShineCommissions: React.FC<{
  transaction: DetailedTransactionFragment;
}> = ({ transaction }) => {
  const { fee, feeType } = transaction;

  const feeWithoutVat = fee / VAT_RATE;

  return (
    <HStack alignItems="top" justify="space-between" spacing="space-16">
      <Text variant="secondary">{locales.fee}</Text>
      <Box textAlign="right">
        <HStack spacing="space-4">
          <Tooltip
            description={locales.formatString(
              locales.feeType[feeType],
              getFeesForType(feeType),
            )}
            marginX="space-16"
          >
            <Box paddingX="space-4">
              <SunshineIcon color="grey.600" name="information" />
            </Box>
          </Tooltip>
          <Text variant="primary">
            {locales.formatString(
              locales.feeWithVat,
              formatAmount({ type: 'payout', value: fee }),
            )}
          </Text>
        </HStack>
        <Text size="sm" variant="light">
          {locales.formatString(
            locales.feeWithoutVat,
            formatAmount({ type: 'payout', value: feeWithoutVat }),
          )}
        </Text>
      </Box>
    </HStack>
  );
};

export default ShineCommissions;
